import { render, staticRenderFns } from "./ZjxxrkForm.vue?vue&type=template&id=471f7069&scoped=true"
import script from "./ZjxxrkForm.vue?vue&type=script&lang=js"
export * from "./ZjxxrkForm.vue?vue&type=script&lang=js"
import style0 from "./ZjxxrkForm.vue?vue&type=style&index=0&id=471f7069&prod&lang=scss&scoped=true"
import style1 from "./ZjxxrkForm.vue?vue&type=style&index=1&id=471f7069&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f7069",
  null
  
)

export default component.exports